import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=2866dc4f&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=2866dc4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2866dc4f",
  null
  
)

export default component.exports